import { cn } from "@/libs/cn";
import { Tag } from "@/modules/common/components";
import { LeadStatus, LeadStatusLabels } from "@/modules/common/types/Leads.enum";

const STATUS_VARIANT = {
  [LeadStatus.IN_CONTACT]: "warning",
  [LeadStatus.DEMO_SCHEDULED]: "primary",
  [LeadStatus.IN_NEGOTIATION]: "primary",
  [LeadStatus.CONVERTED]: "success",
  [LeadStatus.LOST]: "danger",
} as const;

const STATUS_CLASS_NAME: Partial<Record<LeadStatus, string>> = {
  [LeadStatus.IN_NEGOTIATION]: "text-ui-primary bg-ui-hover border-ui-border-muted",
};

interface LeadStatusTagProps {
  status: LeadStatus;
  className?: string;
}

const LeadStatusTag = ({ status, className }: LeadStatusTagProps) => (
  <Tag label={LeadStatusLabels[status] ?? status} variant={STATUS_VARIANT[status]} className={cn(STATUS_CLASS_NAME[status], className)} />
);

export default LeadStatusTag;
